<template>
	<div>
		<el-dialog
			:close-on-click-modal="false"
			:show-close="false"
			:visible.sync="isShowHint"
			center
			title="提示"
			top="35vh"
			width="40%">
			<div class="u-m-t-20 u-m-b-20">
				我已知晓：本保单
				<span class="red-bold">仅承保施工地址在广东省内的工程项目</span>
				。如施工地址在广东省外，保险人不承担任何赔偿责任。
			</div>
			<template slot="footer">
				<el-button class="u-m-r-20" plain type="primary" @click="onHaveAccount(0)">
					谢谢，投/被保险人不同意此告知。
				</el-button>
				<el-button class="u-m-l-20" type="primary" @click="onHaveAccount(1)">
					已知悉，我已告知投/被保险人，并取得投/被保险人的同意。
				</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'jianzhuHintDialog',
	mixins: [],
	components: {},
	props: {},
	data() {
		return {
			isShowHint: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		showJianzhuHint() {
			this.isShowHint = true
		},
		//0 不同意，1 同意
		onHaveAccount(type) {
			this.isShowHint = false
			this.$emit('onJianzhuHint', type)
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}

::v-deep .el-checkbox__label {
	margin-top: 4px;
}
</style>
